const COOKIEBOT_CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline']

export function hasCookiebotManager(contentSettings = {}) {
  return Boolean(contentSettings && contentSettings.cookieBot && contentSettings.cookieBot.cbid)
}

export function getCookiebotConsent() {
  if (typeof window === 'undefined' || !window.Cookiebot || !window.Cookiebot.consent) {
    return null
  }

  return window.Cookiebot.consent
}

export function hasCookiebotCategoryConsent(category) {
  if (category === 'necessary') {
    return true
  }

  const consent = getCookiebotConsent()
  return Boolean(consent && consent[category])
}

export function hasAnyCookiebotConsent(categories = []) {
  const categoriesArray = Array.isArray(categories) ? categories : [categories]
  return categoriesArray.filter(Boolean).some(hasCookiebotCategoryConsent)
}

export function runWhenCookiebotConsentGranted(contentSettings = {}, categories = [], callback) {
  if (typeof callback !== 'function') {
    return () => {}
  }

  let disposed = false
  let hasRun = false
  const categoriesArray = Array.isArray(categories) ? categories : [categories]

  const detachListeners = () => {
    if (typeof window === 'undefined') {
      return
    }

    COOKIEBOT_CONSENT_EVENTS.forEach(eventName => {
      window.removeEventListener(eventName, tryRun)
    })
  }

  const tryRun = () => {
    if (disposed || hasRun) {
      return
    }

    if (!hasCookiebotManager(contentSettings) || !categoriesArray.length || hasAnyCookiebotConsent(categoriesArray)) {
      hasRun = true
      detachListeners()
      callback()
    }
  }

  if (typeof window !== 'undefined') {
    COOKIEBOT_CONSENT_EVENTS.forEach(eventName => {
      window.addEventListener(eventName, tryRun)
    })
  }

  tryRun()

  return () => {
    disposed = true
    detachListeners()
  }
}
